export default function FeatureCards() {
  const features = [
    {
      icon: 'ri-hotel-bed-line',
      title: '五星级奢华住宿',
      description: '超过1700间精致客房与套房，融合现代奢华与东方美学，每间均可俯瞰表演湖或路氹美景',
    },
    {
      icon: 'ri-restaurant-2-line',
      title: '米其林星级餐饮',
      description: '汇聚多家米其林星级餐厅，涵盖粤菜、日本料理、西餐扒房等环球顶级美食体验',
    },
    {
      icon: 'ri-shopping-bag-3-line',
      title: '顶级品牌购物',
      description: '超过50个国际奢侈品牌旗舰店汇聚名店街，享受免税购物与专属私人导购服务',
    },
    {
      icon: 'ri-water-flash-line',
      title: '表演湖音乐喷泉',
      description: '占地8英亩的震撼水舞表演，数千喷泉配合音乐与灯光，日夜呈现不同的视觉盛宴',
    },
  ];

  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">
            尊享体验
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900">
            永利皇宫 · 四大核心体验
          </h2>
          <p className="text-foreground-600 text-sm mt-3 max-w-lg mx-auto">
            每一处细节都彰显着极致的奢华与品味，为您打造难忘的澳门假期
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group p-6 md:p-7 rounded-xl bg-background-100 border border-secondary-200/60 hover:border-primary-300/50 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 mb-5 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2.5">
                {feature.title}
              </h3>
              <p className="text-foreground-600 text-sm leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}